const resizeZebraMan = debounce(() => {
  if (windowWidth() > breakpointMd) {
    const buildCv = document.querySelector('.build-your-cv');

    if (buildCv) {
      const cvPos = buildCv.getBoundingClientRect();
      const textPos = buildCv.querySelector('.build-your-cv__text span').getBoundingClientRect();
      const zebraMan = buildCv.querySelector('.build-your-cv__zebra-man');

      if (zebraMan) {
        const space = cvPos.bottom - textPos.bottom;

        zebraMan.style.height = `${space}px`;
      }
    }
  }
}, 50);

window.addEventListener('load', () => {
  resizeZebraMan();
});
window.addEventListener('resize', () => {
  resizeZebraMan();
});
